import React, { ComponentType } from 'react';
import { Navigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Role } from '@bloomays-lib/types.shared';
import { LoaderGlobal } from '@bloomays-lib/ui.shared';
import { useAuthStore, useUserStore } from '../stores';
import { isAuth0TokenRefreshError } from '@bloomays-lib/common.auth/browser';
interface ProtectedRouteProps {
  Component: ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ Component }: ProtectedRouteProps): React.JSX.Element => {
  const auth = useAuthStore((state) => state.auth);
  const bloomaysUser = useUserStore((state) => state.user)?.bloomer;
  const authRoles = auth?.user?.roles || [];
  const authUser = auth?.user;
  const isInvitationRoute = window.location.pathname.includes('/invite/');
  if (isInvitationRoute) {
    return <Component />;
  }
  if (!auth?.isAuthenticated) {
    if (auth?.error && isAuth0TokenRefreshError(auth.error) && auth?.logout) {
      auth?.logout();
      return <LoaderGlobal waitingText="Session expirée, redirection vers la connexion..." />;
    }
    auth?.loginWithRedirect({
      appState: { returnTo: `${window.location.pathname}${window.location.search}` },
    });
    return <LoaderGlobal waitingText="Redirection vers l'authentification" />;
  }

  if (authUser?.roles?.includes(Role.Anonymous)) {
    return <Component />;
  }
  if (auth?.isAuthenticated && authUser?.email_verified === false) {
    return <Navigate to="/forbidden/norole" />;
  }

  if (auth?.isAuthenticated && authRoles.length === 1 && authRoles.includes(Role.Bloomer) && !bloomaysUser) {
    return <Navigate to="/forbidden/notrecognized" />;
  }
  const invitation = bloomaysUser?.invitation?.[0];
  if (invitation) {
    if (invitation.status !== 'done' && !(window.location.href.indexOf(`${invitation.token}`) > -1)) {
      return <Navigate to={`/invite/${invitation.token}`} />;
    }
  }

  const ComponentAuthenticate = withAuthenticationRequired(Component, {
    onRedirecting: () => <LoaderGlobal waitingText="Redirection vers l'authentification" />,
  });
  return <ComponentAuthenticate />;
};
export default ProtectedRoute;
